import { useState } from "react";

const BROCHURE_FORM_URL = "https://readdy.ai/api/form/d74im14prit363gl0meg";
const ADVERTISE_FORM_URL = "https://readdy.ai/api/form/d74im14prit363gl0mf0";

/* ─── BROCHURE ──────────────────────────────────────────────── */
export function BrochureSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((val, key) => data.append(key, val.toString()));
    try { await fetch(BROCHURE_FORM_URL, { method: "POST", body: data }); } catch { /* ignore */ }
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-stone-800 to-stone-700 rounded-2xl p-6 text-white relative overflow-hidden">
        <div className="absolute right-6 top-1/2 -translate-y-1/2 opacity-10">
          <i className="ri-file-text-line text-[120px]" />
        </div>
        <div className="relative">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/15 text-xs font-semibold mb-3">
            <i className="ri-file-text-line" /> Dijital & Basılı Broşür
          </span>
          <h2 className="text-2xl font-bold mb-2">Broşür Talep Et</h2>
          <p className="text-white/70 text-sm max-w-md">
            İşletmenizi tanıtan profesyonel broşürler ile ziyaretçilere ulaşın.
            Dijital veya basılı format seçeneği mevcuttur.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Packages */}
        <div className="space-y-4">
          <h3 className="font-semibold text-stone-800">Broşür Paketleri</h3>
          {[
            { icon: "ri-file-text-line", title: "Dijital Broşür", desc: "PDF formatında, sosyal medya paylaşımına uygun", price: "Ücretsiz", color: "bg-emerald-50 text-emerald-700" },
            { icon: "ri-printer-line", title: "Basılı Broşür (A4)", desc: "250 gr kuşe kağıt, 50 adet minimum", price: "₺850 / 50 adet", color: "bg-stone-50 text-stone-700" },
            { icon: "ri-layout-2-line", title: "Trifold Broşür", desc: "Otel ve lokasyonlara dağıtım için ideal", price: "₺1.200 / 100 adet", color: "bg-amber-50 text-amber-700" },
          ].map((pkg) => (
            <div key={pkg.title} className="bg-white rounded-2xl border border-stone-100 p-4 flex items-start gap-4">
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${pkg.color}`}>
                <i className={`${pkg.icon} text-lg`} />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-stone-800 text-sm">{pkg.title}</h4>
                <p className="text-xs text-stone-400 mt-0.5">{pkg.desc}</p>
              </div>
              <span className="text-sm font-bold text-stone-700 whitespace-nowrap">{pkg.price}</span>
            </div>
          ))}
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl border border-stone-100 p-5">
          {submitted ? (
            <div className="flex flex-col items-center justify-center h-full py-8 text-center">
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-emerald-600 text-2xl" />
              </div>
              <p className="font-bold text-stone-800 text-lg">Talebiniz Alındı!</p>
              <p className="text-sm text-stone-400 mt-2">Ekibimiz en kısa sürede sizinle iletişime geçecektir.</p>
              <button onClick={() => setSubmitted(false)} className="mt-4 text-emerald-700 text-sm hover:underline cursor-pointer">Yeni Talep Oluştur</button>
            </div>
          ) : (
            <>
              <h3 className="font-semibold text-stone-800 mb-4">Talep Formu</h3>
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-3">
                <input type="hidden" name="business_name" value="Kebapçı İskender" />
                <input type="hidden" name="email" value="info@iskender.com.tr" />
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Broşür Türü *</label>
                  <select name="brochure_type" required className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none cursor-pointer text-stone-700">
                    <option value="">Seçin...</option>
                    <option value="digital">Dijital Broşür (Ücretsiz)</option>
                    <option value="a4">Basılı A4 Broşür</option>
                    <option value="trifold">Trifold Broşür</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Adet</label>
                  <input name="quantity" type="number" min="50" step="50" placeholder="50" className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Teslimat Adresi</label>
                  <input name="delivery_address" type="text" placeholder="Adres..." className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Özel Notlar</label>
                  <textarea name="notes" rows={3} maxLength={500} placeholder="Özel tasarım istekleri..." className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 resize-none" />
                </div>
                <button type="submit" disabled={loading}
                  className="w-full py-3 bg-emerald-700 hover:bg-emerald-800 text-white rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60">
                  {loading ? "Gönderiliyor..." : "Broşür Talep Et"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─── ADVERTISE ─────────────────────────────────────────────── */
export function AdvertiseSection() {
  const [selectedPkg, setSelectedPkg] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const packages = [
    { id: "basic",   title: "Temel",   price: "₺1.500/ay", features: ["Kategori sayfası banner", "500 gösterim/gün", "1 ay geçerli"], color: "border-stone-200" },
    { id: "pro",     title: "Pro",     price: "₺3.500/ay", features: ["Ana sayfa kartı", "Editör Seçimi rozeti", "2.000 gösterim/gün", "3 ay geçerli"], color: "border-emerald-400", badge: "Popüler" },
    { id: "premium", title: "Premium", price: "₺7.000/ay", features: ["Hero alan reklamı", "Sponsorlu içerik", "Sınırsız gösterim", "6 ay geçerli", "Özel muhabir desteği"], color: "border-amber-400" },
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedPkg) return;
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((val, key) => data.append(key, val.toString()));
    data.append("package", selectedPkg);
    try { await fetch(ADVERTISE_FORM_URL, { method: "POST", body: data }); } catch { /* ignore */ }
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-amber-700 to-amber-600 rounded-2xl p-6 text-white relative overflow-hidden">
        <div className="absolute right-6 top-1/2 -translate-y-1/2 opacity-10">
          <i className="ri-megaphone-line text-[120px]" />
        </div>
        <div className="relative">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/15 text-xs font-semibold mb-3">
            <i className="ri-megaphone-line" /> Reklam & Sponsorlu İçerik
          </span>
          <h2 className="text-2xl font-bold mb-2">İşletmenizi Öne Çıkarın</h2>
          <p className="text-white/80 text-sm max-w-md">
            Binlerce Bursa ziyaretçisine doğrudan ulaşın. Paket seçin, formunuzu doldurun.
          </p>
        </div>
      </div>

      {submitted ? (
        <div className="bg-white rounded-2xl border border-stone-100 p-12 text-center">
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-check-line text-amber-600 text-2xl" />
          </div>
          <p className="font-bold text-stone-800 text-lg mb-2">Reklam Talebiniz Alındı!</p>
          <p className="text-stone-400 text-sm">Ekibimiz 24 saat içinde sizinle iletişime geçecektir.</p>
          <button onClick={() => setSubmitted(false)} className="mt-5 text-emerald-700 text-sm hover:underline cursor-pointer">Yeni Talep</button>
        </div>
      ) : (
        <>
          {/* Packages */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {packages.map((pkg) => (
              <div key={pkg.id}
                onClick={() => setSelectedPkg(pkg.id)}
                className={`bg-white rounded-2xl border-2 p-5 cursor-pointer transition-all relative ${
                  selectedPkg === pkg.id ? "border-emerald-500 shadow-md" : pkg.color + " hover:border-stone-300"
                }`}>
                {pkg.badge && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-emerald-600 text-white text-xs font-bold rounded-full whitespace-nowrap">
                    {pkg.badge}
                  </span>
                )}
                {selectedPkg === pkg.id && (
                  <div className="absolute top-3 right-3 w-6 h-6 rounded-full bg-emerald-600 flex items-center justify-center">
                    <i className="ri-check-line text-white text-xs" />
                  </div>
                )}
                <h3 className="font-bold text-stone-800 text-lg mb-1">{pkg.title}</h3>
                <div className="text-xl font-bold text-stone-700 mb-4">{pkg.price}</div>
                <ul className="space-y-2">
                  {pkg.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs text-stone-600">
                      <i className="ri-check-line text-emerald-600" /> {f}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Form */}
          {selectedPkg && (
            <div className="bg-white rounded-2xl border border-stone-100 p-5">
              <h3 className="font-semibold text-stone-800 mb-4">
                <span className="capitalize">{selectedPkg}</span> Paketi — Talep Formu
              </h3>
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                <input type="hidden" name="business_name" value="Kebapçı İskender" />
                <input type="hidden" name="email" value="info@iskender.com.tr" />
                <input type="hidden" name="package" value={selectedPkg} />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs text-stone-500 mb-1.5">Başlangıç Tarihi</label>
                    <input name="start_date" type="date" required className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 cursor-pointer" />
                  </div>
                  <div>
                    <label className="block text-xs text-stone-500 mb-1.5">Telefon</label>
                    <input name="phone" type="tel" defaultValue="+90 224 221 4615" className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
                  </div>
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Özel Notlar</label>
                  <textarea name="notes" rows={3} maxLength={500} placeholder="Hedef kitle, özel istekler..."
                    className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 resize-none" />
                </div>
                <button type="submit" disabled={loading}
                  className="w-full py-3 bg-amber-600 hover:bg-amber-700 text-white rounded-xl text-sm font-semibold transition-colors cursor-pointer disabled:opacity-60 whitespace-nowrap">
                  {loading ? "Gönderiliyor..." : "Reklam Talebini Gönder"}
                </button>
              </form>
            </div>
          )}
        </>
      )}
    </div>
  );
}

/* ─── CONTACT ───────────────────────────────────────────────── */
export function ContactSection() {
  const [sent, setSent] = useState(false);
  const [msg, setMsg] = useState("");

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!msg.trim()) return;
    setSent(true);
    setMsg("");
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-stone-700 to-stone-600 rounded-2xl p-6 text-white">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/15 text-xs font-semibold mb-3">
          <i className="ri-mail-send-line" /> Yönetici İletişim
        </span>
        <h2 className="text-2xl font-bold mb-1">Site Yöneticisi ile İletişim</h2>
        <p className="text-white/70 text-sm">Sorularınız, önerileriniz veya acil durumlar için doğrudan mesaj gönderin.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Contact info */}
        <div className="bg-white rounded-2xl border border-stone-100 p-5">
          <h3 className="font-semibold text-stone-800 mb-4">İletişim Kanalları</h3>
          <div className="space-y-4">
            {[
              { icon: "ri-customer-service-2-line", label: "Destek Hattı", value: "+90 224 000 0000", sub: "Hafta içi 09:00 – 18:00", color: "bg-emerald-50 text-emerald-700" },
              { icon: "ri-mail-line", label: "E-posta", value: "destek@bursaguide360.com", sub: "24 saat içinde yanıt", color: "bg-sky-50 text-sky-700" },
              { icon: "ri-whatsapp-line", label: "WhatsApp", value: "+90 224 000 0001", sub: "Hızlı yanıt için", color: "bg-emerald-50 text-emerald-700" },
            ].map((c) => (
              <div key={c.label} className="flex items-start gap-4">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${c.color}`}>
                  <i className={`${c.icon} text-lg`} />
                </div>
                <div>
                  <p className="text-xs text-stone-400">{c.label}</p>
                  <p className="font-semibold text-stone-800 text-sm">{c.value}</p>
                  <p className="text-xs text-stone-400">{c.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Ortalama yanıt süresi */}
          <div className="mt-5 pt-5 border-t border-stone-100 flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-50">
              <i className="ri-time-line text-amber-600 text-lg" />
            </div>
            <div>
              <p className="text-xs text-stone-400">Ortalama Yanıt Süresi</p>
              <p className="font-bold text-stone-800">2-4 Saat</p>
            </div>
          </div>
        </div>

        {/* Message form */}
        <div className="bg-white rounded-2xl border border-stone-100 p-5">
          {sent ? (
            <div className="flex flex-col items-center justify-center h-full py-8 text-center">
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-check-line text-emerald-600 text-2xl" />
              </div>
              <p className="font-bold text-stone-800">Mesajınız Gönderildi!</p>
              <p className="text-sm text-stone-400 mt-1">En kısa sürede yanıt alacaksınız.</p>
            </div>
          ) : (
            <>
              <h3 className="font-semibold text-stone-800 mb-4">Mesaj Gönder</h3>
              <form onSubmit={handleSend} className="space-y-4">
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Konu</label>
                  <input type="text" required placeholder="Konu..."
                    className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400" />
                </div>
                <div>
                  <label className="block text-xs text-stone-500 mb-1.5">Mesaj</label>
                  <textarea value={msg} onChange={(e) => setMsg(e.target.value)} required rows={6} maxLength={500}
                    placeholder="Mesajınızı yazın..." className="w-full px-4 py-2.5 border border-stone-200 rounded-xl text-sm outline-none focus:border-emerald-400 resize-none" />
                  <p className="text-xs text-stone-400 text-right mt-1">{msg.length}/500</p>
                </div>
                <button type="submit"
                  className="w-full py-3 bg-stone-800 hover:bg-stone-900 text-white rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
                  <i className="ri-send-plane-line" /> Mesajı Gönder
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
